<template>
  <div class="help ml-2 popup-hint">
    <button
      :class="{ [bgColor]: bgColor }"
      class="
        bg-gray-400
        flex
        justify-center
        items-center
        text-white
        w-4
        h-4
        p-1
        rounded-full
        focus:outline-none
      "
      @click="showHint = !showHint"
    >
      <span class="text-sm">?</span>
    </button>
    <div
      v-if="showHint && textHint"
      class="popup-hint-content"
    >
      {{ textHint }}
    </div>
    <div
      v-if="showHint && (image || description)"
      class="popup-hint-content-advanced"
    >
      <div class="flex popup_content text-gray-800">
        <div
          class="popup_content__image mr-4"
          v-if="image"
        >
          <img
            :src="image"
            class="img-responsive"
          />
        </div>
        <div
          class="popup_content__description"
          v-if="description"
        >
          {{ description }}
        </div>
      </div>
      {{ textHint }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    textHint: {
      type: String,
      required: false,
    },
    bgColor: {
      type: String,
      required: false,
      default: "bg-gray-400",
    },
    image: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      showHint: false,
    };
  },
};
</script>

